import React from 'react';
import { LockIcon, MailIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export const Footer: React.FC = () => {
  return <footer className="bg-gray-900 text-gray-400" data-id="element-71">
      <div className="max-w-6xl mx-auto py-12 px-4" data-id="element-72">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-73">
          <div data-id="element-74">
            <div className="flex items-center gap-2 mb-4" data-id="element-75">
              <LockIcon className="w-5 h-5 text-green-400" data-id="element-76" />
              <h3 className="text-white font-bold" data-id="element-77">Pago Seguro</h3>
            </div>
            <p className="text-sm mb-4" data-id="element-78">
              Todos los pagos están protegidos con encriptación SSL de 256 bits.
              Tus datos están completamente seguros.
            </p>
            <PaymentBadges data-id="element-79" />
          </div>

          <div data-id="element-80">
            <h3 className="text-white font-bold mb-4" data-id="element-81">Contacto</h3>
            <div className="flex items-center gap-2 text-sm" data-id="element-82">
              <MailIcon className="w-4 h-4" data-id="element-83" />
              <a href="mailto:info@activapleno.com" className="hover:text-white transition-colors" data-id="element-84">
                info@activapleno.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 space-y-4 text-sm text-center" data-id="element-85">
          <p data-id="element-86">
            <strong data-id="element-87">Producto Digital:</strong> Este es un producto digital. No
            se envía ningún producto físico. Todos los materiales son
            descargables en formato PDF.
          </p>

          <p data-id="element-88">
            © {new Date().getFullYear()} Megapack Fútbol Listo. Todos los
            derechos reservados.
          </p>

          <p className="text-xs" data-id="element-89">
            Este sitio no es parte de Facebook ni está respaldado por Facebook
            Inc. FACEBOOK es una marca registrada de FACEBOOK Inc.
          </p>
        </div>
      </div>
    </footer>;
};